import gzBkImg from './bk-img/bk-img.module';
import gzImgSrc from './img-src/img-src.module';

export default angular.module('gazelle.components.printosImages', [
  gzBkImg,
  gzImgSrc,
])
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/printos-images/printos-images.module.js